import { render, staticRenderFns } from "./EmisionDetalleNew.vue?vue&type=template&id=703049bc&scoped=true"
import script from "./EmisionDetalleNew.vue?vue&type=script&lang=js"
export * from "./EmisionDetalleNew.vue?vue&type=script&lang=js"
import style0 from "./EmisionDetalleNew.vue?vue&type=style&index=0&id=703049bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703049bc",
  null
  
)

export default component.exports